import React, {RefObject} from 'react';
import {observer} from 'mobx-react';
import {MagicMarkerComponent, Multiparty} from '@techsee/techsee-nway-media-service-client';
import {IVideoController} from './VideoController';
import {RemoveParticipantModal} from './RemoveParticipantModal.component';
import './VideoComponent.scss';

export type VideoComponentProps = {
    controller: IVideoController;
};

@observer
export class VideoComponent extends React.Component<VideoComponentProps> {
    render() {
        const {controller} = this.props;
        const {translate, multipartyController, magicMarkerController} = controller;

        if (!multipartyController) {
            return <React.Fragment />;
        }

        const translations = {
            connectingCaption: translate('FACEMEET.VIDEO.CONNECTING'),
            waitingForFirstPeerCaption: translate('FACEMEET.VIDEO.WAITING_FOR_CLIENT'),
            mediaRejectedAccessDeniedTooltip: translate('FACEMEET.VIDEO.TOOLTIP.PERMISSION_DENIED'),
            mediaRejectedUserDeniedPermission: translate('FACEMEET.VIDEO.USER_DENIED_PERMISSION'),
            mediaRejectedPermissionDeniedTitle: translate('FACEMEET.VIDEO.PERMISSION_DENIED_TITLE'),
            mediaRejectedPermissionDeniedText: translate('FACEMEET.VIDEO.PERMISSION_DENIED_TEXT'),
            pinToScreen: translate('REACT.NWAY.PIN_TO_SCREEN'),
            pinnedToScreen: translate('REACT.NWAY.PINNED'),
            removeFromCall: translate('REACT.NWAY.REMOVE_FROM_CALL')
        };

        const remoteDrawings = magicMarkerController.remoteDrawings;
        const magicMarkerOptions = magicMarkerController.options;
        const magicMarker =
            magicMarkerController.shouldDisplayComponent &&
            controller.allowMagicMarker &&
            (({floatingElements}: {floatingElements: RefObject<HTMLElement>[]}) => (
                <MagicMarkerComponent
                    options={magicMarkerOptions}
                    onDrawingsUpdate={magicMarkerController.sendDrawings}
                    remoteDrawings={remoteDrawings}
                    onRemoteDrawingsDisplayEnd={magicMarkerController.clearRemoteDrawings}
                    floatingElements={floatingElements}
                />
            ));

        return (
            <div className='nway-video-wrapper'>
                <Multiparty
                    controller={multipartyController}
                    selectedLayoutType={controller.videoLayoutType}
                    onPinnedUserChanged={controller.onPinnedUserChangeRequested}
                    onSnapshotRequested={controller.onSnapshotRequested}
                    // @ts-ignore - available after rebuilding techsee-nway-media-service-client
                    onRemoveParticipant={
                        controller.canRemoveParticipant ? controller.onRemoveParticipantRequested : undefined
                    }
                    isPeerMediaPermissionRejected={controller.isPeerMediaPermissionRejected}
                    translations={translations}
                    //@ts-ignore
                    videoOverlay={magicMarker}
                />
                <RemoveParticipantModal ctrl={controller} />
            </div>
        );
    }
}
